import React from "react";

/**
 * Section title used across pages — light, editorial.
 * Not a big card container: we deliberately avoid heavy borders
 * so the layout stays as a thin fil of content.
 */
export function ScreenTitle({ eyebrow, title, right }) {
  return (
    <div className="px-5 pt-6 pb-4 flex items-end justify-between gap-3" data-testid="screen-title">
      <div className="min-w-0">
        {eyebrow && <div className="caption mb-1.5">{eyebrow}</div>}
        <h1 className="font-headings text-3xl leading-none tracking-tight truncate">
          {title}
        </h1>
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
